export const SUPPORTED_DRAFT_OPERATION_TYPES = ['rack_changes'] as const
export type DraftOperationType = typeof SUPPORTED_DRAFT_OPERATION_TYPES[number]

export type DraftOperation = {
  type: DraftOperationType
  payload: Record<string, unknown>
  scope: { kind: 'floor_plan'; rackIds: string[]; positions: string[]; pathwayKeys: string[] }
  preview: { added: number; updated: number; deleted: number }
}

export function createRackChangesOperation(diff: {
  added?: unknown[]
  updated?: Record<string, unknown>
  deleted?: unknown[]
}): DraftOperation {
  const added = diff.added ?? []
  const updated = diff.updated ?? {}
  const deleted = diff.deleted ?? []
  return {
    type: 'rack_changes',
    payload: { added, updated, deleted },
    scope: {
      kind: 'floor_plan',
      rackIds: [
        ...Object.keys(updated),
        ...deleted.map(String),
      ],
      positions: [...added, ...Object.values(updated)]
        .filter((item): item is Record<string, unknown> => Boolean(item) && typeof item === 'object')
        .flatMap(item => item.row_index != null && item.rack_index != null
          ? [`${item.row_index}:${item.rack_index}`]
          : []),
      pathwayKeys: [],
    },
    preview: {
      added: added.length,
      updated: Object.keys(updated).length,
      deleted: deleted.length,
    },
  }
}

export function assertSupportedDraftOperation(operation: { type?: string }): asserts operation is DraftOperation {
  if (!SUPPORTED_DRAFT_OPERATION_TYPES.includes(operation.type as DraftOperationType)) {
    throw new Error(`Unsupported draft operation type: ${operation.type ?? 'missing'}`)
  }
}
